import React from 'react';
import styled from 'styled-components';

import ContentContainer from '@/components/ContentContainer';

import Main from './components/Main';
import Top from './components/Top';

const BlogView = () => {
  return (
    <Component>
      <ContentContainer>
        <Top />
        <Main />
      </ContentContainer>
    </Component>
  );
};

export default BlogView;

const Component = styled.div``;
